import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, map } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Booking } from "@app/core/booking/domain/model/booking";
import { BookingMapper } from "@app/core/booking/data/network/booking.mapper";

@Injectable({
  providedIn: "root",
})
export class DeleteBookingWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(bookingId: string, token: string): Observable<void> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.DELETE_BOOKING_ENDPOINT(bookingId))
      .setMethod(HttpMethod.post)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.baseHandler.execute(parameters);
  }
}
